import { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const sep = () => <div style={{ margin: '64px 0' }} />;

const SectionTitle = ({ children }) => (
  <>
    <h2 className="concept-section-title">{children}</h2>
    <div style={{ width: '48px', height: '3px', backgroundColor: '#000', marginBottom: '28px' }} />
  </>
);

const Body = ({ children, style }) => (
  <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '16px', color: '#4A4A4A', lineHeight: '1.9', margin: '0 0 20px 0', ...style }}>
    {children}
  </p>
);

export default function NotreConception() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Notre Engagement — Four A Tacos';
  }, []);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#fff', display: 'flex', flexDirection: 'column' }}>
      <Header />

      {/* Hero */}
      <div className="hero-banner" style={{ backgroundColor: '#C10230', paddingTop: '80px' }}>
        <div style={{ position: 'relative', zIndex: 1, textAlign: 'center', padding: '0 24px' }}>
          <h1 className="hero-title" style={{ letterSpacing: '4px' }}>
            Notre Engagement
          </h1>
        </div>
      </div>

      <main style={{ flex: 1, maxWidth: '860px', width: '100%', margin: '0 auto', padding: 'clamp(32px, 6vw, 80px) clamp(16px, 5vw, 48px)', boxSizing: 'border-box' }}>

        {/* Notre engagement */}
        <section>
          <p className="concept-quote">
            « Chez Four a Tacos nous faisons des produits pour tout le monde mais pas comme tout le monde car la qualité est au centre de nos préoccupations. »
          </p>
        </section>

        {sep()}

        {/* Produits à la commande */}
        <section style={{ position: 'relative' }}>
          <img src="/chrono.png" alt="chrono" className="concept-icon" />
          <SectionTitle>Des produits préparés à la commande</SectionTitle>
          <Body>
            Nous faisons toujours nos produits à la main, à la commande et avec amour. Nos cuisines ouvertes permettent à nos clients de voir le processus de fabrication de nos produits afin de garantir une transparence totale.
          </Body>
        </section>

        {sep()}

        {/* Nos ingrédients */}
        <section style={{ position: 'relative' }}>
          <img src="/legume.png" alt="légume" className="concept-icon" />
          <SectionTitle>Nos ingrédients</SectionTitle>
          <p className="concept-quote" style={{ margin: '32px 0' }}>
            « Un bon produit c'est d'abord de bons <span style={{ whiteSpace: 'nowrap' }}>ingrédients. »</span>
          </p>
          <Body>
            Les légumes, fromages et viandes sont sélectionnés avec soin pour leurs qualités nutritionnelles et leurs saveurs. Nos produits contiennent un maximum de légumes frais préparés soigneusement.
          </Body>
        </section>

        {sep()}

        {/* Nos fromages */}
        <section style={{ position: 'relative' }}>
          <img src="/fromage.png" alt="fromage" className="concept-icon" />
          <SectionTitle>Nos fromages</SectionTitle>
          <Body>
            Nous avons choisi des fromages de Savoie AOP (Appellation d'Origine Protégée) et IGP (Indication Géographique Protégée) pour leur saveur et leur qualité.
          </Body>
        </section>

        {sep()}

        {/* Sauce fromagère */}
        <section style={{ position: 'relative' }}>
          <img src="/saucefromagere.png" alt="sauce fromagère" className="concept-icon" />
          <SectionTitle>Une recette de sauce fromagère exclusive</SectionTitle>
          <Body>
            Une sauce fromagère exclusive qui rend nos tacos si unique et si savoureux, dont la recette est secrètement gardée.
          </Body>
        </section>

      </main>

      <Footer />
    </div>
  );
}
